import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { Dumbbell } from "lucide-react";

const STATUS = { actif: "Actif", suspendu: "Suspendu", resilie: "Résilié", en_retard: "En retard" };
const COLOR = { actif: "#059669", suspendu: "#D97706", resilie: "#868E96", en_retard: "#E60000" };
const FORMULES = { mensuel: "Mensuel", trimestriel: "Trimestriel", annuel: "Annuel", seance: "À la séance" };

export default function ChefAbonnes() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/abonnes"
      eyebrow="Sport / Coaching · Abonnés"
      title="Membres abonnés"
      sub="Pilotez vos adhérents, formules et renouvellements."
      testidPrefix="abonne"
      allowEdit
      defaultRow={() => ({ nom: "", prenom: "", email: "", telephone: "", formule: "mensuel", date_debut: new Date().toISOString().slice(0, 10), date_fin: "", prix_paye: 0, status: "actif", notes: "" })}
      columns={[
        { key: "nom", label: "Nom" },
        { key: "prenom", label: "Prénom", width: "140px" },
        { key: "formule", label: "Formule", width: "130px", render: (v) => FORMULES[v] || v },
        { key: "date_debut", label: "Début", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "date_fin", label: "Fin", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "prix_paye", label: "Payé", width: "100px", render: (v) => <span className="font-mono">{(v || 0).toFixed(2)} €</span> },
        { key: "status", label: "Statut", width: "120px", render: (v) => <span className="text-[9px] uppercase font-bold px-2 py-0.5" style={{ color: COLOR[v], background: `${COLOR[v]}15` }}>{STATUS[v] || v}</span> },
      ]}
      fields={[
        { key: "nom", label: "Nom", span: 6, required: true },
        { key: "prenom", label: "Prénom", span: 6, required: true },
        { key: "email", label: "Email", span: 6 },
        { key: "telephone", label: "Téléphone", span: 6 },
        { key: "formule", label: "Formule", type: "select", span: 6, options: Object.entries(FORMULES).map(([v, l]) => ({ value: v, label: l })) },
        { key: "status", label: "Statut", type: "select", span: 6, options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "date_debut", label: "Date début", type: "date", span: 4, required: true },
        { key: "date_fin", label: "Date fin", type: "date", span: 4 },
        { key: "prix_paye", label: "Prix payé (€)", type: "number", step: "0.01", span: 4 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={Dumbbell}
      emptyText="Aucun membre."
    />
  );
}
